import React, { FC } from 'react';
import { Button } from 'antd';
import { CaretRightOutlined, CaretLeftOutlined } from '@ant-design/icons';

type Props = {
  moveHiddenColumnsToShown: () => void;
  moveShownColumnsToHide: () => void;
};

const Interaction: FC<Props> = ({ moveHiddenColumnsToShown, moveShownColumnsToHide }) => {
  return (
    <div>
      <Button style={{ marginBottom: '1rem' }} type='primary' onClick={moveHiddenColumnsToShown}>
        <CaretRightOutlined />
      </Button>
      <Button type='primary' onClick={moveShownColumnsToHide}>
        <CaretLeftOutlined />
      </Button>
    </div>
  );
};

export default Interaction;
